import { fetch } from '../../utils/dataAccess';

export function error(error) {
  return { type: 'LIVEINTERVIEW_ACTIVATE_ERROR', error };
}

export function loading(loading) {
  return { type: 'LIVEINTERVIEW_ACTIVATE_LOADING', loading };
}

export function success(activated) {
  return { type: 'LIVEINTERVIEW_ACTIVATE_SUCCESS', activated };
}

export function activate(item) {
  return dispatch => {
    dispatch(loading(true));
    dispatch(error(null));

    return fetch(item['@id'] + '/activate', { method: 'PUT' })
      .then(() => {
        dispatch(loading(false));
        dispatch(success(item));
      })
      .catch(e => {
        dispatch(loading(false));
        dispatch(error(e.errors));
      });
  };
}

export function reset() {
  return { type: 'LIVEINTERVIEW_ACTIVATE_RESET' };
}
